<div class="main-layout">
	<a vis-logo class="logo" aria-label="ZEISS Logo"></a>
	<div class="text">We'll be right back</div>
	<div class="header">Engineering Order Portal</div>
	<div class="subtext">The application is undergoing scheduled maintenance</div>
</div>
